import { render, staticRenderFns } from "./TravelRequestNotification.vue?vue&type=template&id=4651e6d5&scoped=true&"
import script from "./TravelRequestNotification.vue?vue&type=script&lang=js&"
export * from "./TravelRequestNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4651e6d5",
  null
  
)

export default component.exports